import { useState, useEffect } from 'react';

function App() {
  const [selectedCoinId, setSelectedCoinId] = useState<number | null>(null);
  const [showAuctionModal, setShowAuctionModal] = useState(false);

  // Listen for coin clicks from the player iframe
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('Received message:', event.data, 'from origin:', event.origin);
      
      // Accept messages from any origin for now (we'll secure this later)
      if (event.data && event.data.type === 'coinClick') {
        console.log('Coin clicked:', event.data.coinId);
        setSelectedCoinId(event.data.coinId);
        setShowAuctionModal(true);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleCloseModal = () => {
    setShowAuctionModal(false);
    setSelectedCoinId(null);
  };

  const handleCoinClick = (coinId: number) => {
    console.log('Coin clicked:', coinId);
    setSelectedCoinId(coinId);
    setShowAuctionModal(true);
  };

  return (
    <div className="unified-container">
      <PlayerIframe onCoinClick={handleCoinClick} />
      
      {showAuctionModal && selectedCoinId && (
        <AuctionModal 
          coinId={selectedCoinId}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}

// Player iframe with clickable coin areas
const PlayerIframe: React.FC<{ onCoinClick: (coinId: number) => void }> = ({ onCoinClick }) => {
  const [availableCoins, setAvailableCoins] = useState<number[]>([]);

  // Load available coins from the player API
  useEffect(() => {
    const loadCoins = async () => {
      try {
        const response = await fetch('https://originalspins-player-staging.hxgp8t6ydd.workers.dev/coins');
        const data = await response.json();
        const coinIds = data.coins?.map((coin: any) => coin.i) || [];
        setAvailableCoins(coinIds);
        console.log('Loaded coins:', coinIds);
      } catch (error) {
        console.error('Error loading coins:', error);
      }
    };

    loadCoins();
  }, []);

  return (
    <div className="player-iframe-container">
      <iframe
        src="https://originalspins-player-staging.hxgp8t6ydd.workers.dev"
        className="player-iframe"
        title="Original Spins Player"
        allow="autoplay; encrypted-media"
      />
      
      {/* Clickable coin overlay - positioned over where coins appear */}
      <div className="coin-click-overlay">
        {availableCoins.map((coinId) => (
          <button
            key={coinId}
            className="coin-click-area"
            onClick={() => onCoinClick(coinId)}
            title={`Click to view Coin #${coinId} auction`}
            style={{
              // Position coins in a grid pattern over the player
              position: 'absolute',
              left: `${(coinId % 5) * 20 + 10}%`,
              top: `${Math.floor(coinId / 5) * 15 + 20}%`,
              width: '15%',
              height: '10%',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              zIndex: 10
            }}
          />
        ))}
      </div>
    </div>
  );
};

// Auction modal - overlay with just the piece view/bid frame
const AuctionModal: React.FC<{ 
  coinId: number; 
  onClose: () => void; 
}> = ({ coinId, onClose }) => {
  const auctionUrl = `https://originalspins-auction-staging.hxgp8t6ydd.workers.dev/?pieceId=${coinId}&v=fromPlayer&modal=true`;

  return (
    <div className="auction-modal-overlay" onClick={onClose}>
      <div className="auction-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="auction-modal-header">
          <h2>Coin #{coinId} Auction</h2>
          <button onClick={onClose} className="close-button">
            ×
          </button>
        </div>
        <iframe
          src={auctionUrl}
          className="auction-modal-iframe"
          title={`Coin ${coinId} Auction`}
        />
      </div>
    </div>
  );
};

export default App;